import React from 'react';
import I18n from '../../blocks/localization';
import { useHistory } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import icon_my_coupons from '../../assets/icons/2x/icon_moji-kuponi.png';
import RoutesConst from '../../blocks/consts/RoutesConst';
import ContentLayout from '../core/ContentLayout';
import { ResponseCode } from '../../models/order/ResponseCode';
import PrometInfoIconBox from '../shared/PrometInfoIconBox';

interface Props {
    responseCode: ResponseCode;
}

const PurchaseCouponInfo = (props: Props) => {

    const history = useHistory();

    const redirect = (route: string) => {
        history.push(route);
    }

    const getText = (): string => {
        switch (props.responseCode) {
            case ResponseCode.Ok:
                return I18n.t('purchaseCouponInfo.successText');
            case ResponseCode.Canceled:
                return I18n.t('purchaseCouponInfo.cancelText');
            case ResponseCode.Error:
                return I18n.t('purchaseCouponInfo.errorText');
        }
    }

    return (
        <ContentLayout titleTranslateId='purchaseCouponInfo.title'>
            <PrometInfoIconBox icon={icon_my_coupons} content={getText()} />

            <Row>
                <Col xl={12}>
                    <Button type="button" color="primary" className="mr-3 mb-3" outline onClick={() => redirect(RoutesConst.Home)}>{I18n.t('purchaseCouponInfo.returnToHome')}</Button>
                    {
                        props.responseCode !== ResponseCode.Ok &&
                        <Button type="button" color="primary" className="mb-3" outline onClick={() => redirect(RoutesConst.MyCoupons)}>{I18n.t('purchaseCouponInfo.tryAgain')}</Button>
                    }
                </Col>
            </Row>
        </ContentLayout>
    );
}

export default PurchaseCouponInfo;
